module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startsOn":"Starts on"},"ar":{"startsOn":"يبدأ في"}}')
  delete Component.options._Ctor
}
